import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import { compose } from "recompose"
import styles from "./styles"
import Card from "@material-ui/core/Card"
import Box from "@material-ui/core/Box"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import Input from "@material-ui/core/Input"
import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import Checkbox from "@material-ui/core/Checkbox"
import FormHelperText from "@material-ui/core/FormHelperText"
import classNames from "classnames"
import LoadingButton from "../../components/LoadingButton"
import { isEmpty, camelCase } from "lodash"
import update from "immutability-helper"
import Button from "@material-ui/core/Button"
import LogoWhite from "../../assets/images/adesk_brand.png"
import Fade from "@material-ui/core/Fade"
import TransitionGroup from "react-transition-group/TransitionGroup"
import FadeAndSlideTransition from "../../Transitions/FadeAndSlide"
import Grid from "@material-ui/core/Grid"
import Hidden from "@material-ui/core/Hidden"

import packageJson from "../../../package.json"
import {
  login,
  register,
  sendPin,
  _toggleLoginDialog,
} from "../../actions/authentication"
import { setVisibility } from "../../actions/message-drawer"
import { toggleProfileDialog } from "../../actions/users"
import { openSnackBar } from "../../actions/snack-bar"
import { switchActiveCompany } from "../../actions/companies"
import PhoneInput from "../../components/PhoneInput/index"
import widthWidth from "@material-ui/core/withWidth"
import { getCurrentHost } from "../../utils/getHost"
const { version } = packageJson

let duration = 150

class LoginDialogForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loginPhone: "",
      loginPassword: "",
      registerFirstName: "",
      registerLastName: "",
      registerEmail: "",
      registerPhone: "",
      registerPassword: "",
      registerCountry: "US",
      forms: {},
      isRegister: false,
      isPin: false,
      pinSent: false,
      pin: ["", "", "", ""],
      delay: "register",
      agreedToTerms: false,
    }
  }
  componentDidMount() {
    this.setUpForms()
    if (
      getCurrentHost() === "crewmama" &&
      this.props.history.location.pathname.includes("register")
    ) {
      this.toggleRegister()
    }
    this.props.dispatch(setVisibility(false))
  }
  componentWillUnmount() {
    // this.props.dispatch(setVisibility(true))
    //close the dialog
    this.props.dispatch(_toggleLoginDialog(false))
  }
  setUpForms = () => {
    const forms = document.querySelectorAll("form")
    forms.forEach(form => {
      const formName = camelCase(form.id)
      const inputs = form.getElementsByTagName("input")
      let newState = update(this.state, {})
      if (!newState.forms[formName]) {
        newState.forms[formName] = {}
      }
      for (let i = 0; i < inputs.length; ++i) {
        newState.forms[formName][inputs[i].name] = {
          validity: inputs[i].validity,
        }
      }
      newState.forms[formName].valid = this.formIsValid(
        newState.forms[formName]
      )
      this.setState(newState)
    })
  }
  clearForms = () => {
    this.setState({
      loginPhone: "",
      loginPassword: "",
      registerFirstName: "",
      registerLastName: "",
      registerEmail: "",
      registerPhone: "",
      registerPassword: "",
      agreedToTerms: false,
      forms: {},
    })
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value
    const validity = e.target.validity
    const formName = camelCase(e.target.form.id)

    let newState = update(this.state, {
      [fieldName]: { $set: value },
      forms: {
        [formName]: {
          [fieldName]: {
            validity: { $set: validity },
          },
        },
      },
    })
    newState.forms[formName].valid = this.formIsValid(newState.forms[formName])
    this.setState(newState)
  }
  onRegisterPhoneCountryChange = country => {
    this.setState({ registerCountry: country })
  }
  handlePhoneInputChange = (formName, fieldName, value) => {
    const validity = document.getElementById(fieldName).validity
    let newState = update(this.state, {
      [fieldName]: { $set: value },
      forms: {
        [formName]: {
          [fieldName]: {
            validity: { $set: validity },
          },
        },
      },
    })
    newState.forms[formName].valid = this.formIsValid(newState.forms[formName])
    this.setState(newState)
  }
  handleInputBlur = e => {
    const fieldName = e.target.name
    let newState = update(this.state, {
      forms: {
        [camelCase(e.target.form.id)]: {
          [fieldName]: {
            touched: { $set: true },
          },
        },
      },
    })
    this.setState(newState)
  }
  fieldIsValid = (inputName, formName) => {
    if (!isEmpty(this.state.forms[formName])) {
      if (this.state.forms[formName][inputName].touched) {
        return this.state.forms[formName][inputName].validity.valid
      } else {
        return true
      }
    } else {
      return true
    }
  }
  formIsValid = form => {
    let formValidArray = []
    for (let key in form) {
      if (key !== "valid") {
        formValidArray.push(form[key].validity.valid)
      }
    }
    return formValidArray.indexOf(false) === -1
  }
  afterLogin = response => {
    //close the dialog
    this.props.dispatch(_toggleLoginDialog(false))
    // this is where we would do any redirects
    //if (
    // this.props.location.state &&
    // this.props.location.state.hasOwnProperty("redirect")
    //  ) {
    // this.props.history.push(this.props.location.state.redirect)
    //  } else {
    // this.props.history.push(`/crew`)
    //  }
    if (response.roles.length === 0) {
      this.props.dispatch(toggleProfileDialog(true, response))
    }
    if (response.companies.length === 1) {
      this.props.dispatch(
        switchActiveCompany(
          response.companies[0].id,
          response.companies[0].managers.find(m => m.id === response.id) ? 1 : 2
        )
      )
    }
    if (!response.has_password) {
      this.props.dispatch(
        openSnackBar({
          message: "Please enter a password to make login easier in the future",
        })
      )
    }
  }
  doLogin = e => {
    e.preventDefault()
    const { loginPhone: phone, loginPassword: password } = this.state
    this.props
      .dispatch(login({ phone, password }))
      .then(response => {
        this.afterLogin(response)
      })
      .catch(err => {
        let message = err.message
        if (err.type === "not found") {
          message = "Account not found"
        } else if (err.type === "pass" || err === "The password was wrong") {
          message = "Password was incorrect"
        } else if (err.message === "Missing credentials") {
          message = "Use 'Forgot Login' to login and set a password"
        }
        this.props.dispatch(
          openSnackBar({
            message,
          })
        )
      })
  }
  doRegister = e => {
    e.preventDefault()
    const {
      registerPhone: phone,
      registerPassword: password,
      registerFirstName: first_name,
      registerLastName: last_name,
      registerEmail: email,
    } = this.state
    if (this.state.agreedToTerms) {
      return this.props
        .dispatch(
          register({
            phone,
            password,
            first_name,
            last_name,
            email,
            countryCode: this.state.registerCountry,
          })
        )
        .then(response => {
          this.afterLogin(response)
        })
        .catch(err => {
          let message = "There was an error with your registration"
          if (err.message === "User creation error") {
            if (err.error.code === "ER_DUP_ENTRY") {
              if (err.error.sqlMessage.indexOf("for key 'phone'") > -1) {
                message = "That phone number is already in our system"
              }
            }
          }
          this.props.dispatch(
            openSnackBar({
              message,
            })
          )
        })
    } else {
      return this.props.dispatch(
        openSnackBar({
          message: "You must agree to the privacy policy to register",
        })
      )
    }
  }
  toggleRegister = () => {
    let delay
    if (this.state.isRegister) {
      delay = "login"
    } else {
      delay = "register"
    }
    this.setState({
      isRegister: !this.state.isRegister,
      delay,
    })
    setTimeout(() => {
      if (!this.state.forms.hasOwnProperty("registerForm")) {
        this.setUpForms()
      }
    }, duration + 100)
  }
  getDelay = formName => {
    return this.state.delay === formName ? duration + 100 : 0
  }
  forgotLogin = () => {
    if (this.state.loginPhone) {
      this.props.dispatch(sendPin(this.state.loginPhone))
      this.setState({ isPin: true, pinSent: true })
    } else {
      this.setState({ isPin: true })
    }
    setTimeout(() => {
      if (!this.state.forms.hasOwnProperty("pinForm")) {
        this.setUpForms()
      }
    }, 230)
  }
  handlePinInputChange = e => {
    const index = parseInt(e.target.name, 10)
    const value = e.target.value
    if (value.length <= 1) {
      let arr = this.state.pin
      arr.splice(index, 1, value)
      this.setState(
        update(this.state, {
          pin: {
            $set: arr,
          },
        })
      )
      if (value) {
        const nextInput = document.getElementById(`pinInput${index + 1}`)
        if (nextInput) {
          nextInput.focus()
        }
      }
    }
  }
  handlePinKeyPress = e => {
    const index = parseInt(e.target.name, 10)
    if (e.keyCode === 8 && this.state.pin[index] === "") {
      const prevInput = document.getElementById(`pinInput${index - 1}`)
      if (prevInput) {
        prevInput.focus()
      }
    }
  }
  resendPin = () => {
    this.props.dispatch(sendPin(this.state.loginPhone)).then(() => {
      this.props.dispatch(
        openSnackBar({
          message: "Pin number resent",
        })
      )
    })
  }
  handlePin = e => {
    e.preventDefault()
    this.setState({ sendingPin: true })
    if (this.state.pinSent) {
      this.props
        .dispatch(
          login({
            phone: this.state.loginPhone,
            auth_code: this.state.pin.join(""),
          })
        )
        .then(res => {
          this.setState({ sendingPin: false })
          this.afterLogin(res)
        })
        .catch(err => {
          this.props.dispatch(
            openSnackBar({
              message: "Pin number was incorrect",
            })
          )
          this.setState({ sendingPin: false })
        })
    } else {
      this.props
        .dispatch(sendPin(this.state.loginPhone))
        .then(() => {
          this.setState({ sendingPin: false, pinSent: true })
        })
        .catch(err => {
          if (err.message.indexOf("for user id #null") > -1) {
            this.props.dispatch(
              openSnackBar({
                message: "No account with that number found",
              })
            )
          } else if (err.message.indexOf("No outgoing SMS number") > -1) {
            this.props.dispatch(
              openSnackBar({
                message: "Could not text pin number",
              })
            )
          } else {
            this.props.dispatch(
              openSnackBar({
                message: "There was an error texting pin number",
              })
            )
          }
        })
    }
  }

  handleCheckbox = name => event => {
    this.setState({ ...this.state, [name]: event.target.checked })
  }

  goToHomesite = () => {
    if (getCurrentHost() === "crewmama") {
      window.location.href = "https://crewmama.com/"
    } else {
      window.location.href = "/"
    }
  }

  render() {
    // duration = this.props.theme.transitions.duration.shorter
    return (
      <div className={this.props.classes.login}>
        <div className={this.props.classes.mainArea}>
          <Card
            classes={{
              root: classNames(this.props.classes.cardRoot, {
                [this.props.classes.isRegister]: this.state.isRegister,
              }),
            }}
          >
            <div className={this.props.classes.formLogoArea}>
              <div className={this.props.classes.formImage} />
            </div>
            <TransitionGroup
              className={classNames(this.props.classes.formGroup, {
                [this.props.classes.loginForm]: !this.state.isRegister,
                [this.props.classes.registerForm]: this.state.isRegister,
              })}
            >
              {!this.state.isRegister && (
                <FadeAndSlideTransition
                  centered
                  duration={duration}
                  delay={this.getDelay("login")}
                  direction="left"
                >
                  <TransitionGroup>
                    {this.state.isPin && (
                      <Fade in>
                        <form
                          className={classNames(this.props.classes.form)}
                          id="pin-form"
                          noValidate
                          autoComplete="off"
                          onSubmit={this.handlePin}
                        >
                          <CardContent
                            classes={{
                              root: this.props.classes.cardContentRoot,
                            }}
                          >
                            {!this.state.pinSent && (
                              <Box marginTop={2}>
                                <PhoneInput
                                  name="loginPhone"
                                  id="loginPhone"
                                  value={this.state.loginPhone}
                                  onChange={value =>
                                    this.handlePhoneInputChange(
                                      "pinForm",
                                      "loginPhone",
                                      value
                                    )
                                  }
                                />
                              </Box>
                            )}
                            {this.state.pinSent && (
                              <Fragment>
                                <Typography variant="caption">
                                  Pin number has been sent to{" "}
                                  <strong>{this.state.loginPhone}</strong> enter
                                  it below to login
                                </Typography>
                                <div
                                  className={this.props.classes.pinInputWrapper}
                                >
                                  <FormControl
                                    fullWidth
                                    className={this.props.classes.pinInput}
                                  >
                                    <Input
                                      type="text"
                                      fullWidth
                                      inputProps={{
                                        required: true,
                                        className: this.props.classes
                                          .pinInputInput,
                                      }}
                                      name="0"
                                      value={this.state.pin[0]}
                                      onChange={this.handlePinInputChange}
                                      onKeyDown={this.handlePinKeyPress}
                                      id="pinInput0"
                                      autoComplete="nope"
                                    />
                                  </FormControl>
                                  <FormControl
                                    fullWidth
                                    className={this.props.classes.pinInput}
                                  >
                                    <Input
                                      type="text"
                                      fullWidth
                                      inputProps={{
                                        required: true,
                                        className: this.props.classes
                                          .pinInputInput,
                                      }}
                                      name="1"
                                      value={this.state.pin[1]}
                                      onChange={this.handlePinInputChange}
                                      onKeyDown={this.handlePinKeyPress}
                                      id="pinInput1"
                                      autoComplete="nope"
                                    />
                                  </FormControl>
                                  <FormControl
                                    fullWidth
                                    className={this.props.classes.pinInput}
                                  >
                                    <Input
                                      type="text"
                                      fullWidth
                                      inputProps={{
                                        required: true,
                                        className: this.props.classes
                                          .pinInputInput,
                                      }}
                                      name="2"
                                      value={this.state.pin[2]}
                                      onChange={this.handlePinInputChange}
                                      onKeyDown={this.handlePinKeyPress}
                                      id="pinInput2"
                                      autoComplete="nope"
                                    />
                                  </FormControl>
                                  <FormControl
                                    fullWidth
                                    className={this.props.classes.pinInput}
                                  >
                                    <Input
                                      type="text"
                                      fullWidth
                                      inputProps={{
                                        required: true,
                                        className: this.props.classes
                                          .pinInputInput,
                                      }}
                                      name="3"
                                      value={this.state.pin[3]}
                                      onChange={this.handlePinInputChange}
                                      onKeyDown={this.handlePinKeyPress}
                                      id="pinInput3"
                                      autoComplete="nope"
                                    />
                                  </FormControl>
                                </div>
                              </Fragment>
                            )}
                          </CardContent>
                          <CardActions
                            classes={{ root: this.props.classes.actionsRoot }}
                          >
                            <Button
                              color="secondary"
                              onClick={() =>
                                this.setState({ isPin: false, pinSent: false })
                              }
                            >
                              Cancel
                            </Button>
                            <Button
                              color="secondary"
                              disabled={!this.state.pinSent}
                              onClick={this.resendPin}
                              type="button"
                            >
                              Send Again
                            </Button>
                            <LoadingButton
                              color="secondary"
                              working={this.state.sendingPin}
                              disabled={
                                this.state.pinSent
                                  ? this.state.pin.join("").length !== 4
                                  : !isEmpty(this.state.forms.pinForm) &&
                                    !this.state.forms.pinForm.valid
                              }
                              type="submit"
                            >
                              Submit
                            </LoadingButton>
                          </CardActions>
                        </form>
                      </Fade>
                    )}
                    {!this.state.isPin && (
                      <Fade in>
                        <form
                          className={classNames(this.props.classes.form)}
                          id="login-form"
                          noValidate
                          autoComplete="off"
                          onSubmit={this.doLogin}
                        >
                          <CardContent
                            classes={{
                              root: this.props.classes.cardContentRoot,
                            }}
                          >
                            <PhoneInput
                              name="loginPhone"
                              id="loginPhone"
                              value={this.state.loginPhone}
                              onChange={value =>
                                this.handlePhoneInputChange(
                                  "loginForm",
                                  "loginPhone",
                                  value
                                )
                              }
                            />
                            <FormControl fullWidth>
                              <InputLabel htmlFor="loginPassword">
                                Password *
                              </InputLabel>
                              <Input
                                type="password"
                                fullWidth
                                inputProps={{ required: true }}
                                name="loginPassword"
                                value={this.state.loginPassword}
                                onChange={this.handleInputChange}
                                onBlur={this.handleInputBlur}
                                id="loginPassword"
                                error={
                                  !this.fieldIsValid(
                                    "loginPassword",
                                    "loginForm"
                                  )
                                }
                                autoComplete="nope"
                              />
                              <FormHelperText error id="loginPassword">
                                {!this.fieldIsValid(
                                  "loginPassword",
                                  "loginForm"
                                ) && <span>Enter password</span>}
                              </FormHelperText>
                            </FormControl>
                            <div
                              className={
                                this.props.classes.forgotLoginButtonWrapper
                              }
                            >
                              <Button
                                color="primary"
                                onClick={this.forgotLogin}
                                className={this.props.classes.forgotLoginButton}
                              >
                                Forgot Login?
                              </Button>
                            </div>
                          </CardContent>
                          <CardActions
                            classes={{ root: this.props.classes.actionsRoot }}
                          >
                            <Button
                              color="secondary"
                              onClick={this.toggleRegister}
                            >
                              Register
                            </Button>
                            <LoadingButton
                              color="secondary"
                              working={this.props.authentication.loggingIn}
                              // disabled={
                              //   !isEmpty(this.state.forms.loginForm) &&
                              //   !this.state.forms.loginForm.valid
                              // }
                              type="submit"
                            >
                              Login
                            </LoadingButton>
                          </CardActions>
                        </form>
                      </Fade>
                    )}
                  </TransitionGroup>
                </FadeAndSlideTransition>
              )}
              {this.state.isRegister && (
                <FadeAndSlideTransition
                  centered
                  duration={duration}
                  delay={this.getDelay("register")}
                  direction="left"
                >
                  <form
                    className={classNames(this.props.classes.form)}
                    id="register-form"
                    noValidate
                    autoComplete="off"
                    onSubmit={this.doRegister}
                  >
                    <CardContent
                      classes={{ root: this.props.classes.cardContentRoot }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth>
                            <InputLabel htmlFor="registerFirstName">
                              First Name *
                            </InputLabel>
                            <Input
                              type="text"
                              fullWidth
                              inputProps={{ required: true }}
                              name="registerFirstName"
                              value={this.state.registerFirstName}
                              onChange={this.handleInputChange}
                              onBlur={this.handleInputBlur}
                              id="registerFirstName"
                              error={
                                !this.fieldIsValid(
                                  "registerFirstName",
                                  "registerForm"
                                )
                              }
                              autoComplete="nope"
                            />
                            <FormHelperText error id="registerFirstName">
                              {!this.fieldIsValid(
                                "registerFirstName",
                                "registerForm"
                              ) && <span>Enter first name</span>}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth>
                            <InputLabel htmlFor="registerLastName">
                              Last Name *
                            </InputLabel>
                            <Input
                              type="text"
                              fullWidth
                              inputProps={{ required: true }}
                              name="registerLastName"
                              value={this.state.registerLastName}
                              onChange={this.handleInputChange}
                              onBlur={this.handleInputBlur}
                              id="registerLastName"
                              error={
                                !this.fieldIsValid(
                                  "registerLastName",
                                  "registerForm"
                                )
                              }
                              autoComplete="nope"
                            />
                            <FormHelperText error id="registerLastName">
                              {!this.fieldIsValid(
                                "registerLastName",
                                "registerForm"
                              ) && <span>Enter last name</span>}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <PhoneInput
                            name="registerPhone"
                            id="registerPhone"
                            value={this.state.registerPhone}
                            onChange={value =>
                              this.handlePhoneInputChange(
                                "registerForm",
                                "registerPhone",
                                value
                              )
                            }
                            onCountryChange={this.onRegisterPhoneCountryChange}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth>
                            <InputLabel htmlFor="registerEmail">
                              Email *
                            </InputLabel>
                            <Input
                              type="email"
                              fullWidth
                              inputProps={{ required: true }}
                              name="registerEmail"
                              value={this.state.registerEmail}
                              onChange={this.handleInputChange}
                              onBlur={this.handleInputBlur}
                              id="registerEmail"
                              error={
                                !this.fieldIsValid(
                                  "registerEmail",
                                  "registerForm"
                                )
                              }
                              autoComplete="nope"
                            />
                            <FormHelperText error id="registerEmail">
                              {!this.fieldIsValid(
                                "registerEmail",
                                "registerForm"
                              ) && <span>Enter email</span>}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth>
                            <InputLabel htmlFor="registerPassword">
                              Password *
                            </InputLabel>
                            <Input
                              type="password"
                              fullWidth
                              inputProps={{ required: true }}
                              name="registerPassword"
                              value={this.state.registerPassword}
                              onChange={this.handleInputChange}
                              onBlur={this.handleInputBlur}
                              id="registerPassword"
                              error={
                                !this.fieldIsValid(
                                  "registerPassword",
                                  "registerForm"
                                )
                              }
                              autoComplete="nope"
                            />
                            <FormHelperText error id="registerPassword">
                              {!this.fieldIsValid(
                                "registerPassword",
                                "registerForm"
                              ) && <span>Enter password</span>}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Hidden smDown>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          className={this.props.classes.registerButtonsWrapper}
                        >
                          <Checkbox
                            color="primary"
                            checked={this.state.agreedToTerms}
                            onChange={this.handleCheckbox("agreedToTerms")}
                            value="agreedToTerms"
                            inputProps={{
                              "aria-label": "agree to terms checkbox",
                            }}
                          />
                          <div>
                            I agree to the{" "}
                            <a href="/privacy-policy" target="_blank">
                              privacy policy
                            </a>
                          </div>
                          <Button
                            color="secondary"
                            onClick={this.toggleRegister}
                            className={this.props.classes.registerButton}
                          >
                            Cancel
                          </Button>
                          <LoadingButton
                            color="secondary"
                            working={this.props.authentication.registering}
                            disabled={
                              !isEmpty(this.state.forms.registerForm) &&
                              !this.state.forms.registerForm.valid
                            }
                            type="submit"
                          >
                            Register
                          </LoadingButton>
                        </Grid>
                      </Hidden>
                      <Hidden mdUp>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          className={
                            this.props.classes.registerButtonsWrapperMobile
                          }
                        >
                          <Checkbox
                            color="primary"
                            checked={this.state.agreedToTerms}
                            onChange={this.handleCheckbox("agreedToTerms")}
                            value="agreedToTerms"
                            inputProps={{
                              "aria-label": "agree to terms checkbox",
                            }}
                          />
                          <div>
                            I agree to the{" "}
                            <a href="/privacy-policy" target="_blank">
                              privacy policy
                            </a>
                          </div>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          className={this.props.classes.registerButtonsMobile}
                        >
                          <Button
                            color="secondary"
                            onClick={this.toggleRegister}
                            className={this.props.classes.registerButton}
                          >
                            Cancel
                          </Button>
                          <LoadingButton
                            color="secondary"
                            working={this.props.authentication.registering}
                            disabled={
                              !isEmpty(this.state.forms.registerForm) &&
                              !this.state.forms.registerForm.valid
                            }
                            type="submit"
                          >
                            Register
                          </LoadingButton>
                        </Grid>
                      </Hidden>
                    </CardContent>
                  </form>
                </FadeAndSlideTransition>
              )}
            </TransitionGroup>
            <div className={this.props.classes.copyRight}>
              <Typography
                className={this.props.classes.copyRightText}
                variant="body1"
              >
                &copy; Copyright{" "}
                {getCurrentHost() === "crewmama"
                  ? "Crew Mama"
                  : "Assignment Desk"}{" "}
                {new Date().getFullYear()}
              </Typography>
            </div>
          </Card>
          <div className={this.props.classes.logoArea}>
            <div className={this.props.classes.spacer} />
            {getCurrentHost() === "adesk" && (
              <div className={this.props.classes.logoWrapper}>
                <img
                  src={LogoWhite}
                  alt={"ADesk"}
                  className={this.props.classes.logo}
                />

                <Typography variant="h6" className={this.props.classes.tagline}>
                  Changing Crew Relationships
                </Typography>
                <Typography
                  variant="subtitle1"
                  className={this.props.classes.secondLine}
                >
                  The CRM for the Production Community
                </Typography>
              </div>
            )}
          </div>
        </div>
        <Typography
          variant="caption"
          color="inherit"
          className={this.props.classes.version}
        >
          {version}
        </Typography>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
  widthWidth()
)(LoginDialogForm)
